// Throttle function to limit the frequency of checks
export default function throttle(fn, limit) {
	let lastCall = 0;
	return function (...args) {
		const now = Date.now();
		if (now - lastCall >= limit) {
			lastCall = now;
			fn(...args);
		}
	};
}

export function onResize(callback) {
	let resizeTimeout;

	// Internal resize handler
	function handleResize(e) {
		// Cancel the previous requestAnimationFrame if it exists
		if (resizeTimeout) {
			cancelAnimationFrame(resizeTimeout);
		}

		// Request a new animation frame
		resizeTimeout = requestAnimationFrame(() => {
			// Call the provided callback function
			callback(e);
		});
	}

	// Add the resize event listener
	window.addEventListener('resize', handleResize);

	// Return a function to remove the listener if needed
	return () => {
		window.removeEventListener('resize', handleResize);
		if (resizeTimeout) {
			cancelAnimationFrame(resizeTimeout);
		}
	};
}

export function onMouseMove(callback) {
	let mouseMoveTimeout;

	// Internal mousemove handler
	function handleMouseMove(e) {
		// Cancel the previous requestAnimationFrame if it exists
		if (mouseMoveTimeout) {
			cancelAnimationFrame(mouseMoveTimeout);
		}

		// Request a new animation frame
		mouseMoveTimeout = requestAnimationFrame(() => {
			// Call the provided callback function
			callback(e);
		});
	}

	// Add the mousemove event listener
	document.addEventListener('mousemove', handleMouseMove);

	// Return a function to remove the listener if needed
	return () => {
		document.removeEventListener('mousemove', handleMouseMove);
		if (mouseMoveTimeout) {
			cancelAnimationFrame(mouseMoveTimeout);
		}
	};
}

export function onScroll(callback) {
	let scrollTimeout;

	// Internal scroll handler
	function handleScroll(e) {
		// Cancel the previous requestAnimationFrame if it exists
		if (scrollTimeout) {
			cancelAnimationFrame(scrollTimeout);
		}

		// Request a new animation frame
		scrollTimeout = requestAnimationFrame(() => {
			// Call the provided callback function
			callback(e);
		});
	}

	// Add the scroll event listener
	window.addEventListener('scroll', handleScroll);

	// Return a function to remove the listener if needed
	return () => {
		window.removeEventListener('scroll', handleScroll);
		if (scrollTimeout) {
			cancelAnimationFrame(scrollTimeout);
		}
	};
}
